module.exports = __webpack_public_path__ + "img/pf.bab3b7a5.svg";